import React from 'react';
import { Users, Target, Award, Heart } from 'lucide-react';
export function AboutSection() {
  return <section className="bg-gradient-to-b from-dark-900 via-dark-700 to-dark-900 py-[80px] px-5" id="nosotros" data-id="element-20" data-mp="2lbwzd5tq8kug">
      <div className="max-w-[1100px] mx-auto" data-id="element-21" data-mp="2gbipdi8kf0ts">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-22" data-mp="2be948es7lbbr">
          Quiénes Somos
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-23" data-mp="27d729q6wql63">
          Conocé la historia detrás de AlphaFit
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-24" data-mp="22juflllsgofz">
          <div data-id="element-25" data-mp="1xmvn17hrwpjw">
            <p className="text-[#ccc] text-[1.05rem] leading-[1.9] mb-6" data-id="element-26" data-mp="1xkhqsvbcx7ar">
              En <strong className="text-white" data-id="element-27" data-mp="1sp2jkm7uu9nb">AlphaFit</strong> nacimos con
              una misión clara: hacer que los suplementos de calidad sean
              accesibles para todos los deportistas en Uruguay.
            </p>
            <p className="text-[#ccc] text-[1.05rem] leading-[1.9] mb-6" data-id="element-28" data-mp="1jp72y1vj5mfw">
              Trabajamos con marcas como{' '}
              <strong className="text-white" data-id="element-29" data-mp="xij8r3p0l40l">Cibeles y Profit</strong> porque
              creemos que no deberías elegir entre calidad y precio. Cada
              producto que ofrecemos está respaldado por fórmulas probadas y
              resultados reales.
            </p>
            <p className="text-[#ccc] text-[1.05rem] leading-[1.9]" data-id="element-30" data-mp="nqn5le82mnpi">
              Con{' '}
              <strong className="text-alphaGold" data-id="element-31" data-mp="1bghly5rlmuei">
                más de 300 clientes satisfechos
              </strong>{' '}
              en todo Uruguay, seguimos creciendo gracias a la confianza de
              quienes eligen entrenar con los mejores suplementos al mejor
              precio.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-5" data-id="element-32" data-mp="3n8d4v8yg9okk">
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-33" data-mp="3n6tkb65rgrcz">
              <Users className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-34" data-mp="3rb9pf57jvur5" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-35" data-mp="1xr97tmtra5i6">
                300+
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-36" data-mp="1st7pj445ma7r">
                Clientes Satisfechos
              </span>
            </div>
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-37" data-mp="1j2d2hxj336l9">
              <Target className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-38" data-mp="1f088uysmy9ym" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-39" data-mp="1eyf0nf2djhoi">
                100%
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-40" data-mp="152c02dn67r3o">
                Productos Originales
              </span>
            </div>
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-41" data-mp="104sbajsujvxh">
              <Award className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-42" data-mp="2zf1qglebyi6b" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-43" data-mp="2uh0ai9c7ayz2">
                Top
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-44" data-mp="32xhf1u4oxi6p">
                Marcas Certificadas
              </span>
            </div>
            <div className="bg-dark-600 border border-dark-300 rounded-lg p-6 text-center" data-id="element-45" data-mp="3bqks41bfbt0t">
              <Heart className="w-8 h-8 text-alphaGold mx-auto mb-3" data-id="element-46" data-mp="3gpnu1cw3xj4k" />
              <span className="text-[2rem] font-black text-alphaGold block" data-id="element-47" data-mp="3govx9yqrxfcp">
                24hs
              </span>
              <span className="text-[0.8rem] text-[#888] uppercase tracking-[1px]" data-id="element-48" data-mp="2k1rco5suijsa">
                Atención por WhatsApp
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}